export default __webpack_public_path__ + "static/2-e145c42cca543918d7028af510ad4d3d.jpg";